import React from "react";
import _ from "lodash";
import { connect } from "react-redux";

@connect(store => {
    return {
        loggedUser: store.loggedUser
    }
})

class Body extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        $('#appendonsend, hr, #divRplyFwdMsg, #x_divRplyFwdMsg, .x_x_container, .x_container').wrapAll('<div class="outlook_quoted"></div>');
        $('.outlook_quoted').next('div').remove();

        $('.gmail_quote').first().before("<div class='ellipsisBtn'><a><i class='material-icons'>more_horiz</i></a></div>")
        $('.yahoo_quoted').first().before("<div class='ellipsisBtn'><a><i class='material-icons'>more_horiz</i></a></div>")
        $('.outlook_quoted').first().before("<div class='ellipsisBtn'><a><i class='material-icons'>more_horiz</i></a></div>")

        $('.ellipsisBtn a').click(function(){
            $('.gmail_quote').toggle();
            $('.yahoo_quoted').toggle();
            $('.outlook_quoted').toggle();
        });
    }

    render() {
        const html  = this.props.html
        // console.log("html String", html)
        // const parseHtml = JSON.parse(html)
        // console.log("htmlpare", parseHtml)
        return (
            <div class="emailViewerBody" dangerouslySetInnerHTML={{ __html: html }}>
            </div>
        )
    }
}

export default Body;